<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :btnRefreshVisible="false" @refresh="onRefresh" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="table-body">
            <paziente-device-list-component ref="cmpPazienteDeviceList" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData"></paziente-device-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import PazienteDeviceListComponent from "../../../paziente/dispositivi/components/PazienteDeviceListComponent.vue";

export default {
    props: {
        utente: { type: Object },
    },
    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        PazienteDeviceListComponent,
    },
    data() {
        return {
            idAccettazione: null,
            btnNuovaRichiestaEsameHidden: true,
            btnNuovaRichiestaUscita: true,
            filtro: {},
            btnNewVisible: true,
            pathResource: null,
            pathResourceAccettazione: "/accettazioni",
            pathSorgente: "/rsapaziente",
            linkedit: null,
            linkback: "/rsagestioneospiti",
            showModalLoading: false,
            listKey: 0,
            jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
        me.setParametri();
        me.loadAccettazione();
        me.$refs.cmpPazienteDeviceList.loadData();
    },
    methods: {
        onRefresh() {
            let me = this;
            me.setParametri();
            me.loadAccettazione();
            me.$refs.cmpPazienteDeviceList.loadData();
        },
        loadAccettazione() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.$refs.cmpRsaAree.init(me.jsonData);
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        setParametri() {
            let me = this;
            me.$refs.cmpPazienteDeviceList.setPathSorgente(me.pathSorgente);
            me.$refs.cmpPazienteDeviceList.setIdPaziete(me.idAccettazione);
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
    },
};
</script>

<style></style>
